module.exports = __webpack_public_path__ + "static/media/support_agent_black_24dp.924e4c64.svg";